import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import wrapInContainerStyles from "@insite/client-framework/Common/wrapInContainerStyles";
import OrderDetailPageTypeLink from "@insite/content-library/Components/OrderDetailPageTypeLink";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import WhitecapColors from "@WhiteCap/Utils/WhiteCapColor";
import React from "react";
import { css } from "styled-components";

interface OwnProps {
    heading: string;
    text: string | number;
    extendedStyles?: SmallHeadingAndTextStyles;
}

export interface SmallHeadingAndTextStyles {
    wrapper?: InjectableCss;
    heading?: TypographyProps;
    text?: TypographyProps;
    extendedStyles?: SmallHeadingAndTextStyles;
}

export const smallHeadingAndTextStyles: SmallHeadingAndTextStyles = {
    wrapper: {
        css: css`
            display: flex;
            flex-direction: column;
            width: 100%;

            @media print {
                display: block;
            }
        `,
    },
    heading: {
        variant: "legend",
        css:css`
        color: ${WhitecapColors.iconColor};
    font-size: 12px !important;
    text-transform: uppercase;
    font-weight: 400;

    ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                css`
                     font-size: 10px !important;
                `,
                css`
                font-size: 10px !important;
                `,
                css``,
                css``,
                css``,
            ])}
        `,
    },
    text: {
        css: css`
            width: 100%;
            font-size: 14px !important;
    text-transform: uppercase;
    /* line-height:5px; */
    font-weight: 500;
            ${wrapInContainerStyles}
            ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                css`
                     font-size: 12px !important;
                `,
                css`
                font-size: 12px !important;
                `,
                css``,
                css``,
                css``,
            ])}
        `,
    },
};

const SmallHeadingAndText: React.FunctionComponent<OwnProps> = ({ heading, text, extendedStyles, ...otherProps }) => {
    const [styles] = React.useState(() => mergeToNew(smallHeadingAndTextStyles, extendedStyles));

    return (
        <StyledWrapper {...styles.wrapper} {...otherProps}>
            <Typography as="p" {...styles.heading} data-test-selector="heading">
                {heading}
            </Typography>
            <Typography as="p" {...styles.text} data-test-selector={`text_${heading}`}>
                {text}
            </Typography>
        </StyledWrapper>
    );
};

export default SmallHeadingAndText;
